// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3HP0w","bigColWidth":"Table_bigColWidth__2UhXo","biggerColWidth":"Table_biggerColWidth__qr437","row":"Table_row__J4Tlk","col":"Table_col__1S6L8"};